export default __webpack_public_path__ + "static/media/133.54a8bf35.gif";